import { PopupManager } from 'element-ui/lib/utils/popup/index'

export function nextIndex() {
  return 100 + PopupManager.nextZIndex()
}
